module.exports = __webpack_public_path__ + "img/big.ae980557.png";